module.exports = __webpack_public_path__ + "static/media/video-icon1.555ee262.svg";